/**
 * gorilla types `userInfo` as JSON, so its shape is unknown until inspected.
 * Readers narrow it here rather than each asserting their own shape.
 */
export const userInfoRecord = (userInfo: unknown): Record<string, unknown> =>
  typeof userInfo === 'object' && userInfo !== null && !Array.isArray(userInfo)
    ? (userInfo as Record<string, unknown>)
    : {};
